// Piezas del bloc de To Do's que viven en el Tablero ("Por atender"): los seguimientos que llegaron y el botón para pasar un aviso de pedidos al bloc.
import { useState } from 'preact/hooks';
import type { SupabaseClient } from '@supabase/supabase-js';
import type { Ir } from '../rutas';
import { Pill } from '../componentes/controles';
import { actualizarPendiente, crearDesdeAlerta, type ResumenAlertas } from '../datos/todo';
import { addDias, hoy } from '../logica/fechas';
import { ordenar, posponerA, textoFecha, type HojaTodo } from '../logica/todo';
import type { Alerta } from '../logica/ventas';

// Seguimientos de To Do's que llegaron: se pueden posponer o dar por hechos sin salir del Tablero.
export function SeguimientosTodo({ sb, ir, r, onCambio }: { sb: SupabaseClient; ir: Ir; r: ResumenAlertas; onCambio: () => void }) {
  const [error, setError] = useState('');
  const dia = hoy();
  const hacer = (id: string, parche: { fecha_seguimiento?: string; hecho?: boolean }) => { setError(''); actualizarPendiente(sb, id, parche).then(onCambio).catch(e => setError(String(e.message || e))); };
  if (!r.alertas.length && !r.manana.length) return null;
  return (
    <>
      {error && <p class="error" role="alert">No se pudo guardar el cambio: {error}</p>}
      {r.alertas.map(f => (
        <li key={f.id} class="td-aviso-fila">
          <button type="button" class="aviso" onClick={() => ir('todo', f.hojaId)}>
            <Pill tono={f.dias < 0 ? 'bad' : 'warn'}>{f.dias < 0 ? 'Vencido' : 'Hoy'}</Pill>
            <span><b>To Do</b> · {f.texto || '(sin texto)'} <span class="sub">Hoja «{f.hoja}» · {textoFecha(f.fecha, dia)}</span></span>
          </button>
          <span class="td-acciones">
            <button type="button" class="btn" onClick={() => hacer(f.id, { fecha_seguimiento: posponerA(dia, 1) })}>+1 día</button>
            <button type="button" class="btn" onClick={() => hacer(f.id, { fecha_seguimiento: posponerA(dia, 7) })}>+1 semana</button>
            <button type="button" class="btn" onClick={() => hacer(f.id, { hecho: true })}>Hecho</button>
          </span>
        </li>
      ))}
      {r.manana.map(f => (
        <li key={f.id}><button type="button" class="aviso" onClick={() => ir('todo', f.hojaId)}>
          <Pill>Mañana</Pill><span><b>To Do</b> · {f.texto || '(sin texto)'} <span class="sub">Hoja «{f.hoja}»</span></span></button></li>
      ))}
    </>
  );
}

// Botón junto a un aviso que viene de pedidos: crea un pendiente por pedido, con fecha, en la hoja que se elija.
export function PasarATodo({ sb, alerta, hojas, onCambio }: { sb: SupabaseClient; alerta: Alerta; hojas: HojaTodo[]; onCambio: () => void }) {
  const activas = ordenar(hojas.filter(h => !h.archivada_en));
  const [abierto, setAbierto] = useState(false), [fecha, setFecha] = useState(addDias(hoy(), 1)), [hojaId, setHojaId] = useState(activas[0]?.id || ''), [ocupado, setOcupado] = useState(false), [msg, setMsg] = useState(''), [error, setError] = useState('');
  if (!activas.length || !alerta.pedidos?.length) return null;
  const crear = () => {
    setOcupado(true); setError('');
    crearDesdeAlerta(sb, alerta.id, alerta.pedidos!, hojaId, fecha).then(({ creados, omitidos }) => {
      const h = activas.find(x => x.id === hojaId)?.nombre || '';
      setMsg(creados ? `Se agregaron ${creados} a «${h}»${omitidos ? ` (${omitidos} ya estaban)` : ''}.` : 'Ya estaban todos en To Do\'s.');
      setAbierto(false); onCambio();
    }).catch(e => setError(String(e.message || e))).finally(() => setOcupado(false));
  };
  return (
    <div class="td-pasar">
      <button type="button" class="btn" aria-expanded={abierto} onClick={() => { setAbierto(!abierto); setMsg(''); }}>＋ To Do's</button>
      {abierto && (
        <div class="td-pasar-form" role="group" aria-label="Pasar a To Do's">
          <label>Hoja <select class="in" value={hojaId} onChange={e => setHojaId(e.currentTarget.value)}>{activas.map(h => <option key={h.id} value={h.id}>{h.nombre}</option>)}</select></label>
          <label>Seguimiento <input class="in" type="date" value={fecha} onChange={e => setFecha(e.currentTarget.value)} /></label>
          <button type="button" class="btn primary" disabled={ocupado || !fecha} onClick={crear}>Agregar {alerta.pedidos.length === 1 ? '1 pendiente' : `${alerta.pedidos.length} pendientes`}</button>
          <button type="button" class="btn link" onClick={() => setAbierto(false)}>Cancelar</button>
        </div>
      )}
      {msg && <span class="sub" role="status">{msg}</span>}
      {error && <span class="error" role="alert">{error}</span>}
    </div>
  );
}
